export const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL
export const GTM_TAG = process.env.REACT_APP_GTM_TAG

export const POD_EU_G_TAG = 'G-8RLSVFLX2M'